// 메인 스토어
export {default as useStationStore} from './useStationStore';

// 도메인별 훅들
export * from './hooks';

// 타입 정의
export * from './types';

/**
 * 🚀 사용법 가이드
 *
 * // 기본 사용법 (기존과 동일)
 * const station = useStationStore(state => state.data.station);
 *
 * // 도메인별 훅 사용 (권장)
 * const { station, timestamp } = useStationData();
 * const { updateStation, updateStationDetail } = useStationDataActions();
 *
 * // UI 상태만
 * const { loading, error } = useStationUI();
 * const { setLoading, setError } = useStationUIActions();
 *
 * // 사용자 권한만
 * const { userPermissions } = useStationUser();
 * const { updateUserPermissions, togglePermission } = useStationUserActions();
 *
 * // 구독 정보만
 * const { subscription } = useStationBusiness();
 * const { updateSubscription } = useStationBusinessActions();
 *
 * // 편의 훅 사용
 * const stationDetail = useStationDetail();
 * const channelArt = useStationChannelArt();
 * const userPermissions = useStationUserPermissions();
 *
 * // 특정 데이터 업데이트
 * const { updateStationDetail } = useStationDataActions();
 * updateStationDetail({ nickname: '새닉네임', title: '새제목' });
 *
 * // 권한 토글
 * const { togglePermission } = useStationUserActions();
 * togglePermission('isFavorite'); // 즐겨찾기 토글
 */
